module.exports = __webpack_public_path__ + "img/source-code-pro-v22-latin-300.34a61457.svg";